import { IClientConfig } from '@front/interfaces/client-config.interface';
import { defaultConfig } from './default.config';

export const bonduelleConfig: IClientConfig = {
  ...defaultConfig,
  powerBiSendBMC: true
};
